export default "__VITE_ASSET__Dkd9akvn__"